import { useContext } from 'react'

import { UserGuideContext } from './UserGuideContext'

export const useUserGuideContext = () => {
  const context = useContext(UserGuideContext)

  if (!context)
    throw new Error(
      'You forgot to wrap your component in <UserGuideContextProvider>',
    )

  return context
}
